import React from "react";
import { InputLabel, styled } from "@mui/material";

const ErrorText = styled(InputLabel)({
  color: "#CC0000",
  fontSize: "12px",
});

function FormikErrorText({ children }) {
  return <ErrorText>{children}</ErrorText>;
}

export default FormikErrorText;
